import { FC } from "react"
import { Icon } from "Components/UI/Icon"
import { Container } from "./styles";

interface INoResults {
  search?: string;
}

export const NoResults: FC<INoResults> = ({ search }) => {
  return (
    <Container>
      <div className="text-container">
        <div className="icon-container">
          <Icon icon='buscar' customSize={24} className="iconSearch" />
        </div>
        <p className="title">
          {`Nenhuma obra encontrada por “${search}”.`}
        </p>
        <p className="description">
          A obra pesquisada não foi encontrada ou não existe. Verifique sua pesquisa e tente novamente.
        </p>
      </div>
    </Container>
  )
}
